import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login-page__wrapper"
}
const _hoisted_2 = { class: "login-page__content" }
const _hoisted_3 = { class: "login-page__register" }
const _hoisted_4 = ["href"]

import { computed, watchEffect } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import LoginContent from "@/account/components/login/login-content.vue";
import { settings } from "@/settings";
import { UrlHelper } from "@/helpers/url-helper";
import useAuthenticationFlows, { authenticationStep } from "../composables/use-authentication-flows";
import { isUserLoggedIn } from "../use-user-account";


export default /*@__PURE__*/_defineComponent({
  __name: 'login-page',
  setup(__props) {

const { openLoginModal } = useAuthenticationFlows();

openLoginModal();

const registerLink = computed(() => settings.url.root + "?akce=registrace");

const redirectLoggedInUrl = computed(() => {
    const returnUrl = UrlHelper.getQueryString("returnurl");
    return returnUrl && !returnUrl.startsWith("//") ? returnUrl : settings.url.root;
});

const redirectLoggedIn = () => {
    window.location.href = redirectLoggedInUrl.value;
};

watchEffect(() => {
    if (isUserLoggedIn.value) {
        redirectLoggedIn();
    }
});

return (_ctx: any,_cache: any) => {
  return (_unref(authenticationStep) != 'None')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(WebpImage, {
            class: "login-page__logo",
            src: "/frontend/kasa-loyalty/img/static/logo.svg",
            alt: "Sazka logo",
            width: "82",
            height: "82"
          }),
          _createVNode(LoginContent)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "login-page__register-text" }, "Nemáte svůj účet?", -1)),
          _createElementVNode("a", {
            class: "login-page__register-link",
            href: registerLink.value
          }, "Registrujte se", 8, _hoisted_4)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})